import { IconButton } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

import ConfirmPopover from '@app/shared/confirmPopover'
import ICON_MAP from '@app/utils/iconMap'
import { useBusinessContextDeleteMutation } from '@graphql/queries'

const DeleteBusinessContextButton = ({ businessContext }) => {
  const navigate = useNavigate()
  const [{ fetching }, deleteBusinessContext] = useBusinessContextDeleteMutation()
  const parentBusinessContextId = businessContext?.parentBusinessContextId

  // No root business context can be deleted
  if (!parentBusinessContextId) {
    return null
  }

  const handleDelete = async () => {
    if (!businessContext) {
      return
    }

    const response = await deleteBusinessContext({
      input: {
        businessContextId: businessContext.id
      }
    })

    if (!response.error) {
      navigate('..')
    }
  }

  return (
    <ConfirmPopover
      header="Delete Business Context"
      body="This action is irreversible and will delete this business context along with all its subfolders and maps. Are you sure you want to proceed?"
      confirmButtonText="Delete"
      loading={fetching}
      onConfirm={handleDelete}
    >
      <IconButton aria-label="Delete business context" variant="ghost" colorPalette="red">
        <ICON_MAP.Delete />
      </IconButton>
    </ConfirmPopover>
  )
}

export default DeleteBusinessContextButton
